<template>
  <nav class="sidenav" :class="'sidenav-' + currentOrientation">
    <slot></slot>
  </nav>
</template>

<style
  src="@/vendor/libs/perfect-scrollbar/perfect-scrollbar.scss"
  lang="scss"
></style>

<script>
import { onMounted, onBeforeUnmount, reactive } from "vue";
import PerfectScrollbar from "perfect-scrollbar";
import { SideNav } from "./sidenav.js"; // Change to ES module import

export default {
  name: "SidenavComponent",
  props: {
    orientation: {
      type: String,
      default: "vertical",
    },
    animate: {
      type: Boolean,
      default: true,
    },
    accordion: {
      type: Boolean,
      default: true,
    },
    closeChildren: {
      type: Boolean,
      default: false,
    },
    showDropdownOnHover: {
      type: Boolean,
      default: false,
    },
    onOpen: Function,
    onOpened: Function,
    onClose: Function,
    onClosed: Function,
  },
  setup(props) {
    // Reactive data
    const state = reactive({
      currentOrientation: props.orientation === "horizontal" ? "horizontal" : "vertical",
      sidenav: null,
    });

    onMounted(() => {
      const sidenavElement = document.querySelector(".sidenav");
      console.log("Sidenav element:", sidenavElement); // Check if this is null

      if (sidenavElement) {
        state.sidenav = new SideNav(
          sidenavElement,
          {
            orientation: state.currentOrientation,
            animate: props.animate,
            accordion: props.accordion,
            closeChildren: props.closeChildren,
            showDropdownOnHover: props.showDropdownOnHover,
            onOpen: props.onOpen,
            onOpened: props.onOpened,
            onClose: props.onClose,
            onClosed: props.onClosed,
          },
          PerfectScrollbar
        );
      } else {
        console.error("Sidenav element not found.");
      }
    });

    onBeforeUnmount(() => {
      if (state.sidenav) state.sidenav.destroy();
      state.sidenav = null;
    });

    return { state, currentOrientation: state.currentOrientation };
  },
};
</script>
